// extracted by mini-css-extract-plugin
export default {"title":"_7M0+zTMGM3ExI7y9DiWeNg==","row":"kbCunhXUTXT3gR8r7FDIOQ==","cell":"YVSGY79S9kDKxNndPVxIuA==","linked":"S0vhyceTktUFdt89XlNvlA=="};